
// @flow

import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import type { PartnerType } from 'types/Settings';

export type StateProps = {
  partners: PartnerType[],
  partnersLink: string,
  partenaires_une_titre: string,
  partenaires_une_description: string,
  partenaires_une_cta: string,
};

type Props = StateProps;

export default class Partners extends PureComponent<Props> {

  renderPartnerCards = () => {
    const { partners } = this.props;

    return partners.map<any>(({ titre, lien, lien_type, logo, description, cta }, index) => {
      return (
        <div key={`partner_${index}_${titre}`} className='col col-md-4 col-lg-4 mb-2 mb-md-0'>
          <div className='card card--ticket card--partner box box--white'>
            <div className='card__header' style={{ backgroundColor: 'rgba(15, 40, 66, 0.08)' }}>
              {logo && 
              <img src={logo} alt={`logo_partner_${titre}`} />}
            </div>
            <div className='card__body'>
              <p className='ft-500 ft-h3 mb-1'>{titre}</p>
              <p className='ft-black-secondary mb-0'>
                {description}
              </p>
            </div>
            <div className='card__footer'>
              { lien_type === 'internal' &&
              <Link
                to={lien}
                className='link-chevron' title={`${titre}`}>
                <span>{cta ? cta : `Consulter sa page`}</span>
                <i className='icon icon-chevron-right' />
              </Link> }
              { lien_type !== 'internal' &&
              <a
                href={lien}
                className='link-chevron'
                target='_blank'
                title={`Lien vers le site ${titre ? titre : ''}`}
                rel='noopener noreferrer'>
                <span>{cta ? cta : `Consulter le site`}</span>
                <i className='icon icon-chevron-right' />
              </a>}
            </div>
          </div>
        </div>
      );
    });
  };

  render() {
    const { renderPartnerCards } = this;
    const { partnersLink, partenaires_une_titre, partenaires_une_description, partenaires_une_cta } = this.props;

    return (
      <>
        {partnersLink && 
        <Link
          to={partnersLink}
          className='link-chevron link-chevron--right section__link section__link--zIndex mt-1' >
          <span>{partenaires_une_cta}</span>
          <i className='icon icon-chevron-right' />
        </Link>}
        <h2 className='mb-3 ft-h3'>{partenaires_une_titre}</h2>
        <p className="mb-3">{partenaires_une_description}</p>
        <div className='row'>
          {renderPartnerCards()}
        </div>
      </>
    );
  }
}
